export default {
  setDarkMode(state) {
    state.darkMode = !state.darkMode
    localStorage.setItem('darkmode', state.darkMode )
  }
}
